<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="`w-${width} h-${height} `"
    width="31.79"
    height="28.17"
    viewBox="0 0 31.79 28.17"
  >
    <path
      id="Unión_19"
      data-name="Unión 19"
      d="M2695.93,1046.724a2.476,2.476,0,1,1,.016,0Zm-10.131,0a2.5,2.5,0,1,1,.046,0Zm-1.26-5.835a1.545,1.545,0,0,1-1.733-1.5q-.853-6.325-1.681-12.653a1.664,1.664,0,0,0-1-1.495c-2.063-.976-4.081-2.049-6.122-3.073a1.461,1.461,0,0,1-.913-1.065,1.236,1.236,0,0,1,.482-1.252,1.3,1.3,0,0,1,1.475-.114q2.566,1.3,5.132,2.6c.826.417,1.641.853,2.477,1.247a1.571,1.571,0,0,1,.99,1.353c.111,1.037.272,2.068.419,3.158h17.919c.05,0,.09.008.138.009h.262l.008.017c1.331.121,1.753.861,1.274,2.307q-1.537,4.64-3.108,9.269a1.515,1.515,0,0,1-1.677,1.194l-7.869,0Z"
      transform="translate(-2672.567 -1019.055)"
      fill="#446daf"
      stroke="rgba(0,0,0,0)"
      stroke-miterlimit="10"
      stroke-width="1"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      default: 6,
    },
    height: {
      default: 5,
    },
  },
};
</script>
